/* 处理权限 */
import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      permissionList: state => state.app.permissionList,
      roleType: state => state.user.roleType,
      saveQuery: state => state.saveQuery,
      publicParams: state => state.publicParams,
      user: state => state.user,
      storeInfo: state => state.storeInfo,
      listNation: state => state.app.listNation,
      listEthnicity: state => state.app.listEthnicity,
    }),
  },
};
